import { c as _c } from "react/compiler-runtime";
import Color from 'color';
import React from 'react';
import { Field, Form } from 'react-final-form';
import Button from '../../button';
import DrawPalette from '../../draw-palette';
import FormError from '../../form-error';
import HelpText from '../../form-help-text';
import { Box, Flex, Grid } from '../../grid';
import useComponentSize from '../../hooks/component-size';
import { useLocalState } from '../../hooks/persisted-state';
import ImageInput from '../../image-input';
import Label from '../../label';
import Select from '../../select';
import useDraw, { toSVG } from '../../use-draw';
import { EMPTY_ARRAY } from '../../utils/constants';
import { ClientFieldReference, FieldPrefixContext, HelpTextField, LabelField, NameField, PrivateField, RequiredField } from './../shared';
const DiagramDraw = React.memo(function Diagramdraw(t0) {
  const $ = _c(43);
  const {
    value,
    onChange,
    imageUrl,
    disabled: t1,
    name
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const data = value || EMPTY_ARRAY;
  const setData = onChange;
  const containerRef = React.useRef(null);
  const {
    width: imageWidth,
    height: imageHeight
  } = useComponentSize(containerRef);
  const [penWidth, setPenWidth] = useLocalState(1, "penWidth");
  const [penColor, setPenColor] = useLocalState("#000000", "penColor");
  const [penType, setPenType] = useLocalState("ballpoint", "penType");
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [redoStack, setRedoStack] = React.useState(t2);
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setRedoStack([]);
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const onStroke = t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      fountain: 0.5,
      ballpoint: 1,
      highlight: 5
    };
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const minPenWidth = t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      fountain: 2,
      ballpoint: 1,
      highlight: 5
    };
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const maxPenWidth = t5;
  let t6;
  if ($[4] !== penColor || $[5] !== penType) {
    t6 = penType === "highlight" ? Color(penColor).alpha(0.25).string() : penColor;
    $[4] = penColor;
    $[5] = penType;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const {
    setCanvas,
    fromData
  } = useDraw(containerRef, data, setData, t6, minPenWidth[penType] * penWidth, maxPenWidth[penType] * penWidth, onStroke);
  let t7;
  if ($[7] !== data || $[8] !== fromData || $[9] !== redoStack || $[10] !== setData) {
    t7 = () => {
      if (redoStack.length) {
        const item = redoStack[redoStack.length - 1];
        setRedoStack(redoStack.filter((_, idx) => idx !== redoStack.length - 1));
        const newData = [...data, item];
        setData(newData);
        fromData(newData);
      }
    };
    $[7] = data;
    $[8] = fromData;
    $[9] = redoStack;
    $[10] = setData;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const redo = t7;
  let t8;
  if ($[12] !== data || $[13] !== fromData || $[14] !== redoStack || $[15] !== setData) {
    t8 = () => {
      if (data.length) {
        const newData_0 = data.filter((__0, idx_0) => idx_0 !== data.length - 1);
        setRedoStack([...redoStack, data[data.length - 1]]);
        setData(newData_0);
        fromData(newData_0);
      }
    };
    $[12] = data;
    $[13] = fromData;
    $[14] = redoStack;
    $[15] = setData;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const undo = t8;
  const t9 = disabled ? "none" : "all";
  let t10;
  if ($[17] !== t9) {
    t10 = {
      userSelect: "none",
      WebkitUserSelect: "none",
      WebkitTouchCallout: "none",
      canvas: {
        pointerEvents: t9,
        position: "absolute"
      }
    };
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== imageHeight || $[20] !== imageWidth || $[21] !== setCanvas) {
    t11 = <canvas height={imageHeight} width={imageWidth} ref={setCanvas} />;
    $[19] = imageHeight;
    $[20] = imageWidth;
    $[21] = setCanvas;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== imageUrl) {
    t12 = <Box as="img" ref={containerRef} src={imageUrl} alt="Content" width="100%" flexGrow={1} display="block" maxWidth="100%" />;
    $[23] = imageUrl;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      position: "absolute",
      bottom: 0,
      right: 0
    };
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== data || $[27] !== penColor || $[28] !== penType || $[29] !== penWidth || $[30] !== redo || $[31] !== redoStack || $[32] !== setPenColor || $[33] !== setPenType || $[34] !== setPenWidth || $[35] !== undo) {
    t14 = <Box p={4} sx={t13} backgroundColor="rgba(255, 255, 255, 0.4)" borderTopLeftRadius={2}><DrawPalette penType={penType} setPenType={setPenType} penColor={penColor} setPenColor={setPenColor} setPenWidth={setPenWidth} penWidth={penWidth} undo={undo} undoStack={data} redo={redo} redoStack={redoStack} /></Box>;
    $[26] = data;
    $[27] = penColor;
    $[28] = penType;
    $[29] = penWidth;
    $[30] = redo;
    $[31] = redoStack;
    $[32] = setPenColor;
    $[33] = setPenType;
    $[34] = setPenWidth;
    $[35] = undo;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== name || $[38] !== t10 || $[39] !== t11 || $[40] !== t12 || $[41] !== t14) {
    t15 = <Box position="relative" width="100%" bg="gray.0" name={name} sx={t10}>{t11}{t12}{t14}</Box>;
    $[37] = name;
    $[38] = t10;
    $[39] = t11;
    $[40] = t12;
    $[41] = t14;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  return t15;
});
const Diagram = t0 => {
  const $ = _c(18);
  const {
    schema,
    menu,
    disabled,
    style,
    className,
    isCustom: t1
  } = t0;
  const isCustom = t1 === undefined ? false : t1;
  const prefix = React.useContext(FieldPrefixContext);
  const t2 = isCustom && "custom_fields";
  let t3;
  if ($[0] !== prefix || $[1] !== schema.name || $[2] !== t2) {
    t3 = [prefix, t2, schema.name].filter(_temp);
    $[0] = prefix;
    $[1] = schema.name;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const name = t3.join(".");
  let t4;
  if ($[4] !== schema.required) {
    t4 = value => {
      if (schema.required && (!value || value.length === 0)) {
        return "Diagram required";
      }
    };
    $[4] = schema.required;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== className || $[7] !== disabled || $[8] !== menu || $[9] !== schema.helptext || $[10] !== schema.image_url || $[11] !== schema.label || $[12] !== style) {
    t5 = t6 => {
      const {
        input,
        meta
      } = t6;
      return <Box style={style} className={className}><Flex mb={2} justifyContent="space-between"><Label sx={{
            flexGrow: 1
          }}>{schema.label}</Label>{menu}</Flex><DiagramDraw disabled={disabled} imageUrl={schema.image_url} {...input} />{meta.error && meta.touched && <FormError>{meta.error}</FormError>}{schema.helptext && <HelpText>{schema.helptext}</HelpText>}</Box>;
    };
    $[6] = className;
    $[7] = disabled;
    $[8] = menu;
    $[9] = schema.helptext;
    $[10] = schema.image_url;
    $[11] = schema.label;
    $[12] = style;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== name || $[15] !== t4 || $[16] !== t5) {
    t6 = <Field name={name} validate={t4}>{t5}</Field>;
    $[14] = name;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
export default Diagram;
export const toString = value => {
  return value || '';
};
export const View = t0 => {
  const $ = _c(11);
  const {
    value,
    schema
  } = t0;
  const ref = React.useRef(null);
  const {
    width,
    height
  } = useComponentSize(ref);
  let t1;
  if ($[0] !== height || $[1] !== value || $[2] !== width) {
    const strokes = value || [];
    t1 = toSVG(strokes, width, height).replace("\n", " ");
    $[0] = height;
    $[1] = value;
    $[2] = width;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const svgDataUri = t1;
  const t2 = `${svgDataUri}`;
  let t3;
  if ($[4] !== t2) {
    t3 = <Box position="absolute" as="img" width="100%" height="100%" alt="drawing" src={t2} />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== schema.image_url) {
    t4 = schema.image_url && <Box as="img" width="100%" ref={ref} alt="image" src={schema.image_url} />;
    $[6] = schema.image_url;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <Box position="relative">{t3}{t4}</Box>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export const Edit = t0 => {
  const $ = _c(13);
  const {
    isEditing,
    className,
    isUniqueFieldName,
    hideRequired,
    showClientFieldReference,
    value,
    menu,
    style,
    disabled
  } = t0;
  const [showMore, setShowMore] = React.useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setShowMore(_temp2);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const toggleMore = t1;
  const removable = value.removable;
  let t2;
  if ($[1] !== className || $[2] !== disabled || $[3] !== hideRequired || $[4] !== isEditing || $[5] !== isUniqueFieldName || $[6] !== menu || $[7] !== removable || $[8] !== showClientFieldReference || $[9] !== showMore || $[10] !== style || $[11] !== value) {
    t2 = <>{!isEditing ? <Form onSubmit={_temp3}>{t3 => <Diagram schema={value} disabled={disabled} menu={menu} style={style} className={className} />}</Form> : <Grid display={!isEditing ? "none" : undefined}><LabelField prefix="" /><Field name="image_url" validate={_temp4}>{_temp5}</Field>{!hideRequired && <RequiredField prefix="" />}<HelpTextField prefix="" />{showMore && <><Field name="print_width">{_temp6}</Field>{showClientFieldReference && removable && <PrivateField prefix="" />}<NameField prefix="" isUniqueFieldName={isUniqueFieldName} removable={removable} />{showClientFieldReference && removable && <ClientFieldReference prefix="" schema={value} />}</>}<Button onClick={toggleMore} size="small" width="100%" variant="outlined">{showMore ? "Show less ..." : "Show more ..."}</Button></Grid>}</>;
    $[1] = className;
    $[2] = disabled;
    $[3] = hideRequired;
    $[4] = isEditing;
    $[5] = isUniqueFieldName;
    $[6] = menu;
    $[7] = removable;
    $[8] = showClientFieldReference;
    $[9] = showMore;
    $[10] = style;
    $[11] = value;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
};
function _temp(v) {
  return v;
}
function _temp2(v) {
  return !v;
}
function _temp3(value_0) {
  return null;
}
function _temp4(value_1) {
  if (!value_1) {
    return "Image required";
  }
}
function _temp5(t0) {
  const {
    input,
    meta
  } = t0;
  return <Box data-sentry-element="Box" data-sentry-component="_temp5" data-sentry-source-file="index.tsx"><Label mb={2} data-sentry-element="Label" data-sentry-source-file="index.tsx">Image</Label><ImageInput {...input} data-sentry-element="ImageInput" data-sentry-source-file="index.tsx" />{meta.error && meta.touched && <FormError>{meta.error}</FormError>}</Box>;
}
function _temp6(t0) {
  const {
    input: input_0
  } = t0;
  return <Box data-sentry-element="Box" data-sentry-component="_temp6" data-sentry-source-file="index.tsx"><Select {...input_0} label="Print width" data-sentry-element="Select" data-sentry-source-file="index.tsx"><option value="">100%</option><option value="75%">75%</option><option value="50%">50%</option></Select></Box>;
}